import { render, staticRenderFns } from "./LabIntro.vue?vue&type=template&id=583d2384&scoped=true&"
import script from "./LabIntro.vue?vue&type=script&lang=js&"
export * from "./LabIntro.vue?vue&type=script&lang=js&"
import style0 from "./LabIntro.vue?vue&type=style&index=0&id=583d2384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d2384",
  null
  
)

export default component.exports